let archivesEmbedded = false;

export function setArchivesEmbedded(embedded: boolean): void {
  archivesEmbedded = embedded;
}

export function isArchivesEmbedded(): boolean {
  return archivesEmbedded;
}

export function archivesListHash(): string {
  return archivesEmbedded ? 'saisons?tab=replays' : 'archives';
}

export function archivesDetailHash(id: number): string {
  return archivesEmbedded ? `saisons?tab=replays&id=${id}` : `archives/${id}`;
}

export function parseReplayIdFromHash(): number | null {
  const raw = window.location.hash.replace(/^#/, '');
  const m = raw.match(/^archives\/(\d+)$/);
  if (m) {
    const id = parseInt(m[1], 10);
    return Number.isNaN(id) ? null : id;
  }
  const view = raw.split('?')[0];
  if (view === 'saisons') {
    const params = new URLSearchParams(raw.includes('?') ? raw.slice(raw.indexOf('?') + 1) : '');
    if (params.get('tab') === 'replays' && params.get('id')) {
      const id = parseInt(params.get('id')!, 10);
      return Number.isNaN(id) ? null : id;
    }
  }
  return null;
}
